/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import { MenuItemEl } from '@material/web/menu/internal/menuitem/menu-item.js';
import { styles } from '@material/web/menu/internal/menuitem/menu-item-styles.js';

export { MenuItem } from '@material/web/menu/internal/controllers/menuItemController.js';
export { CloseMenuEvent } from '@material/web/menu/internal/controllers/shared.js';

/**
 * @summary Menus display a list of choices on a temporary surface.
 *
 * @description
 * Menu items are the selectable choices within the menu. Menu items must
 * implement the `MenuItem` interface and also have the `ix-menu-item`
 * attribute.
 *
 * Menu items can control a menu by selectively firing the `close-menu` and
 * `deselect-items` events.
 *
 * @final
 * @suppress {visibility}
 */
export class IxMenuItem extends MenuItemEl {
  static override styles = [styles];
}
